import {Form} from "antd";
import React, {FC} from "react";
import {toast} from "react-toastify";
import {Contentbar} from "../../../ui/Sidebar";
import {LoadingIcon} from "../../../ui/Icons";
import useDrawer from "../../../hooks/useDrawer";
import Loading from "../../../ui/Loading/Loading";
import StatusSelect from "../../../components/StatusSelect/StatusSelect";
import {useGetAdStatusQuery} from "./__generated__/AdsStatus.query.generated";
import {useChangeAdStatusMutation} from "./__generated__/AdsStatus.mutatin.generated";



const AdsDrawerStatus:FC = () => {
  const { id, closeChildrenHandler } = useDrawer();
  const [form] = Form.useForm<{ statusID: string }>();

  const { data, loading, error } = useGetAdStatusQuery({ variables: { id }});

  const [changeHandler, { loading: changeLoading }] = useChangeAdStatusMutation({
    onCompleted: () => {
      closeChildrenHandler();
      toast.success('Изменение статуса прошло успешно!');
    },
    onError: () => {
      toast.success('При изменение статуса прозошла ошибка!');
    }
  });


  const handleSubmit = () => {
    form.validateFields().then((values) =>  changeHandler({ variables: { adsID: id, ...values }}));
  };


  if (loading || !data) {
    return (
      <Loading><LoadingIcon /></Loading>
    );
  }

  if (error) {
    return <p>{error.message}</p>;
  }

  if (!data?.getAdById) {
    return <p>Возможно произошла ошибка или ID был пуст</p>;
  }

  return (
    <Contentbar isLoading={changeLoading} onSubmit={handleSubmit} onClose={closeChildrenHandler}>
      <h2>Смена статуса объявления:</h2>
      <p>Для продолжения укажите нужный статус и нажмите кнопку <b>"Подтвердить".</b></p>
      <Form
        form={form}
        layout="vertical"
        hideRequiredMark
        autoComplete="off"
        initialValues={{
          device: {
            price: {
              auction: false
            }
          }
        }}
      >
        <Form.Item
          name="statusID"
          rules={[{ required: true, message: 'Заполните поле' }]}
        >
          <StatusSelect
            showSearch={true}
            allowClear={true}
            placeholder="Выберите статус"
            defaultValue={data.getAdById.status.title}
          />
        </Form.Item>
      </Form>
    </Contentbar>
  )
}

export default AdsDrawerStatus;
